import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Menu,
  MenuItem,
  TextField,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import React, { useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useUser } from "../contexts/UserContextProvider";
import useApi from "../hooks/useApi";
import { decodeJwt } from "../utils/utils";
import Loading from "../components/Loading";
import { useGlobalSnackbar } from "../contexts/SnackbarContext";
import Logo from "../assets/LogoPC.PNG";
import { useTranslation } from "react-i18next";
import { KeyboardArrowUp, Done, KeyboardArrowDown, Translate } from "@material-ui/icons";

const useStyles = makeStyles({
  content: {
    maxWidth: "300px",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    margin: "auto",
  },
  card: {
    margin: "auto",
    padding: "3%",
  },
  title: {
    fontSize: "1rem",
    margin: 0,
    fontWeight: 400,
  },
  cardTitle: {
    textAlign: "left",
  },
  field: {
    paddingBottom: "5%",
  },
  button: {
    width: "100%",
  },
  forgotPassword: {
    marginTop: "1rem",
  },
  languageButton: {
    textTransform: "none",
    margin: "0.5rem 0.5rem 0 auto",
  },
});

function Login() {
  const { t, i18n } = useTranslation(["views", "common"]);
  const classes = useStyles();
  const history = useHistory();
  const [, setUser] = useUser();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [clinicCode, setClinicCode] = useState("");
  const setGlobalSnackbar = useGlobalSnackbar();

  const [open, setOpen] = useState(false);
  const anchorEl = useRef();

  const languages = [
    { code: "en", label: "English" },
    { code: "es", label: "Espanol" },
    { code: "fr", label: "Francais" },
    { code: "it", label: "Italiano" },
  ];
  const currentLanguage = (
    i18n.resolvedLanguage ||
    i18n.language ||
    "it"
  ).split("-")[0];

  const api = useApi();

  const handleUsername = (e) => {
    setEmail(e.target.value);
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
  };

  const handleClincCode = (e) => {
    setClinicCode(e.target.value);
  };

  async function handleClick(e) {
    e.preventDefault();
    setLoading(true);
    const response = await api("users/login", "POST", {
      email,
      password,
      clinicCode: clinicCode.trim(),
    });
    if (response.ok !== false) {
      const accessToken = response.accessToken;
      const payload = decodeJwt(accessToken);
      setUser({ accessToken, profile: payload });
      history.push("/");
      return;
    }
    setGlobalSnackbar({
      open: true,
      severity: "error",
      message: `${t("common:errors.login")}`,
    });
    setLoading(false);
  }

  return (
    <div className={classes.content}>
      <Loading loading={loading} />
      <Card className={classes.card}>
        <div style={{ display: "flex" }}>
          <Button
            className={classes.languageButton}
            aria-controls="language-menu"
            aria-haspopup="true"
            onClick={() => setOpen(true)}
            ref={anchorEl}
              endIcon={open ? <KeyboardArrowUp />:<KeyboardArrowDown />}
          >
            <Translate />
          </Button>
          <Menu
            id="language-menu"
            anchorEl={anchorEl?.current}
            keepMounted
            open={open}
            getContentAnchorEl={null}
            onClose={() => setOpen(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
          >
            {languages.map((lang) => (
              <MenuItem
                key={lang.code}
                selected={lang.code === currentLanguage}
                onClick={() => {
                  i18n.changeLanguage(lang.code);
                  setOpen(false);
                }}
              >
                {currentLanguage == lang.code ? (
                  <Done fontSize="small" />
                ) : (
                  <span style={{ width: 24 }} />
                )}
                {lang.label}
              </MenuItem>
            ))}
          </Menu>
        </div>
        <div >
          <img style={{marginRight:"auto", marginLeft:"auto"}} src="https://www.psycare.it/wp-content/uploads/2025/06/LOGO_COMPLETO_LOGOTIPO_NERO-1.png" alt="logo" width={"50%"}/>
          <h1 className={classes.title}>{t("views:login.subtitle")}</h1>
        </div>

        <CardHeader
          title={t("views:login.title")}
          className={classes.cardTitle}
        />
        <CardContent>
          <form onSubmit={handleClick}>
            <div className={classes.field}>
              <TextField
                name="clinicCode"
                type="text"
                id="clinicCode"
                label={t("common:label.clinical_code")}
                required
                value={clinicCode}
                onChange={handleClincCode}
                size="small"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className={classes.field}>
              <TextField
                name="email"
                type="email"
                id="Email"
                label={t("common:label.email")}
                required
                value={email}
                onChange={handleUsername}
                size="small"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className={classes.field}>
              <TextField
                type="password"
                id="Password"
                label={t("common:label.password")}
                required
                value={password}
                onChange={handlePassword}
                size="small"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div>
              <Button
                type="submit"
                className={classes.button}
                variant="contained"
                color="primary"
                endIcon={<ArrowForwardIcon />}
              >
                {t("common:button.login")}
              </Button>
            </div>
          </form>
          <div className={classes.forgotPassword}>
            <Link to="/forgot-password">
              <p>{t("common:link.forgot_password")}</p>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default Login;
